import { createMeetingRoomRequestContext } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";

/** The rooms request for the window the page shows, so the list, the map and the details always agree. */
export const useRoomsRequest = () => {
  const { building, floor, rooms } = useRequiredContext(HaNContext);

  return createMeetingRoomRequestContext({
    buildingId: building.buildingId ?? "",
    selectedFloorId: floor.floorId,
    startDateTime: rooms.roomDateTimes.startDateTime,
    endDateTime: rooms.roomDateTimes.endDateTime,
  });
};
